import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PoPageImpl from './PoPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PoPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PoPageImpl />
    )

}